import http from "@/http-common";
import lambdahttp from "@/http-lambda-common";
const baseurl = process.env.VUE_APP_AWS_SALENOTE_API

class KDPMasterMaintenanceDataService {
  checkDistrbutorCodeExist(data:any): Promise<any> {
      const url = baseurl + `/kdpsalesnote`;
      return lambdahttp.post<any>(url, data)
  }
  getKDPConfirmerInfo(data: any): Promise<any> {
    return http.api.post("/getKDPConfirmerInfo/",data);
  }
  getKDPUserInfo(data: any): Promise<any> {
    return http.api.post("/getKDPUserInfo/",data);
  }
  deleteConfirmerInfo(data: any): Promise<any> {
    return http.api.post("/deleteConfirmerInfo/",data);
  }
  addorUpdateConfirmerInfo(data: any): Promise<any> {
    return http.api.post("/addorUpdateConfirmerInfo/",data);
  }
}
export default new KDPMasterMaintenanceDataService();
